module.exports = __webpack_public_path__ + "fonts/Circe-ExtraBold.e9db35e9.woff";